import { assert } from '~/lib/customAssert'
import { DayOfWeek } from '~/features/campaigns/regularlyPublish/CampaignPublishSchedulePicker'
import { WeekDay } from '~/generated/graphql'

type Schedule = {
  [key: string]: boolean
}

export const getPossibleWeekDayAndMinutes = (schedules: Schedule) => {
  const values = Object.entries(schedules)
    .filter(([_, value]) => value)
    .map(([key]) => key)

  const weekDaysPattern = Object.values(WeekDay).join('|')

  const PickerKeyPattern = new RegExp(`^(?<day>${weekDaysPattern})_(?<hour>[01]?[0-9]|2[0-3]):(?<minute>00|30)$`)

  return values.map((v) => {
    const match = v.match(PickerKeyPattern)
    assert(match && match.groups, `Invalid key format: ${v}`)
    const { day, hour, minute } = match.groups
    return {
      possibleMinutes: Number(hour) * 60 + Number(minute),
      weekDay: day as DayOfWeek,
    }
  })
}
